var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avatar"},[_c('router-link',{attrs:{"to":_vm.viewProfile(_vm.user)}},[_c('img',{attrs:{"src":_vm.user.picture}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }